var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('a-upload',{attrs:{"name":"upfile","multiple":_vm.multiple,"action":_vm.uploadAction,"data":_vm.params,"fileList":_vm.showList,"beforeUpload":_vm.beforeUpload},on:{"change":_vm.handleChange}},[[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(_vm._s(_vm.text)+" ")],1)]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }